import { NgModule } from '@angular/core';
import { TruncateCharactersPipe } from './truncate-characters.pipe';
import { TruncateWordsPipe } from './truncate-words.pipe';
export var TRUNCATE_PIPES = [TruncateCharactersPipe, TruncateWordsPipe];
var TruncateModule = (function () {
    function TruncateModule() {
    }
    TruncateModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TRUNCATE_PIPES],
                    exports: [TRUNCATE_PIPES]
                },] },
    ];
    /** @nocollapse */
    TruncateModule.ctorParameters = function () { return []; };
    return TruncateModule;
}());
export { TruncateModule };
//# sourceMappingURL=truncate.module.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/ng2-truncate/dist/truncate.module.js
// module id = ../../../../ng2-truncate/dist/truncate.module.js
// module chunks = 4